import { render, staticRenderFns } from "./VehiclesFilters.vue?vue&type=template&id=509f96d0&"
import script from "./VehiclesFilters.vue?vue&type=script&lang=js&"
export * from "./VehiclesFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports